<template>

  <div class="OHowPeopleUseLifferyFamily">
    <div class="product-image" :style="cardStyle">
      <div></div>
    </div>

    <div class="person">
      <div class="face">
        <img
          src="@/assets/landing-pages/forPeople/2023/face-the-family.svg" alt="Liffery family"/>
      </div>

      <div class="description content pr-2">
        <h2 class="mb-6">
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyFamily.title') }}
        </h2>
        <p>
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyFamily.text') }}
        </p>
        <p>
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyFamily.text2') }}
        </p>
        <p class="mt-6">
          <router-link
            v-if="getIsAuthenticated"
            :to="{name: routeNames.ROUTE_DASHBOARD}"
          >
            <b-button type="is-primary" class="lfr-button ">
              {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
            </b-button>
          </router-link>
          <b-button
            v-else
            class="is-primary"
            @click="loginPrompt"
          >
            {{ $tc('page.whatIsLiffery.new2023.tryItOut') }}
          </b-button>
        </p>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
.OHowPeopleUseLifferyFamily {
  display: flex;
  justify-content: center;
  gap: 4rem;
  padding: 0;
  background-color: $landingPageCream;

  .product-image {
    width: 50%;
    height: 65vh;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;

    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: cover;

    img.gte920 {
      width: 451px;
      filter: drop-shadow(0px 3.27px 15px rgba(0, 0, 0, 0.25));
    }

    img.lt920 {
      display: none;
      width: 351px;
      filter: drop-shadow(0px 3.27px 15px rgba(0, 0, 0, 0.25));
    }

    @media screen and (max-width: 920px) {
      img.gte920 {
        display: none;
      }

      img.lt920 {
        display: block;
      }
    }
  }

  .person {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4rem;
    width: 50%;

    .description {
      width: 400px;
    }
  }

  @media screen and (max-width: $desktop) {
    .product-image {
      width: 100%;
      background-position-x: center;

      img {
        width: 350px;
        margin-left: auto;
        margin-right: auto;
      }
    }
    .person {
      width: unset;
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;
      margin-top: 4rem;
    }
  }

  @media screen and (max-width: $tablet) {
    flex-direction: column-reverse;
    padding-top: 4rem;

    .product-image {
      height: 45vh;
    }

    .person {
      flex-direction: column;
      align-items: center;
      gap: 2rem;

      .description {
        width: 90%;
        margin: auto;
        text-align: center;
      }
    }
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AuthenticationStore } from '@/store';
import { RouteNames } from '@/router/RouteNames';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';
import ALink from '@/components/atoms/link/ALink.vue';

@Component({
  components: { ALink }
})
export default class OHowPeopleUseLifferyFamily extends Vue {
  get cardStyle () {
    /* eslint-disable */
    return `
      background-image: url(${require('../../../../assets/landing-pages/forPeople/2023/Liffery-shopping-list-cards.png')});
      backgroundImage: -webkit-image-set(
        url(${require('../../../../assets/landing-pages/forPeople/2023/Liffery-shopping-list-cards.png')}) 1x,
        url(${require('../../../../assets/landing-pages/forPeople/2023/Liffery-shopping-list-cards2x.png')}) 2x,
      );
      backgroundImage: image-set(
        url(${require('../../../../assets/landing-pages/forPeople/2023/Liffery-shopping-list-cards.png')}) 1x,
        url(${require('../../../../assets/landing-pages/forPeople/2023/Liffery-shopping-list-cards2x.png')}) 2x,
      );
    `;
    /* eslint-enable */
  }

  routeNames = RouteNames;

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_SIGNUP({
      state: true,
      metaData: {
        registeredFromAction: EnumRegisteredFromAction.ctaGiveList
      }
    });
  }
}
</script>
